


import React, { useState, useEffect } from 'react';
import { ref, onValue } from "firebase/database";
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { FiShoppingBag, FiMenu, FiX, FiUser, FiPackage, FiLogOut, FiSearch } from 'react-icons/fi';
import logo from '../assets/logo.png';
import logo1 from '../assets/logo3.png';
import { FiChevronRight } from "react-icons/fi";


const Navbar = ({ user }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [userProfileOpen, setUserProfileOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [ordersCount, setOrdersCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [screenSize, setScreenSize] = useState({
    isMobile: window.innerWidth < 768,
    isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
    isDesktop: window.innerWidth >= 1024
  });
  const navigate = useNavigate();

  const [userData, setUserData] = useState(() => {
    return user || JSON.parse(localStorage.getItem('userData')) || null;
  });

  useEffect(() => {
    if (user) {
      setUserData(user);
    }
  }, [user]);

  // Enhanced responsive handling with multiple breakpoints
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenSize({
        isMobile: width < 768,
        isTablet: width >= 768 && width < 1024,
        isDesktop: width >= 1024
      });

      // Close mobile menu on desktop
      if (width >= 1024) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (userData?.id) {
      // Cart count
      const cartRef = ref(db, `Watch/customers/${userData.id}/cart`);
      const cartUnsubscribe = onValue(cartRef, (snapshot) => {
        const cartData = snapshot.val();
        const count = cartData ? Object.keys(cartData).length : 0;
        setCartCount(count);
      });

      // Orders count
      const ordersRef = ref(db, `Watch/customers/${userData.id}/orders`);
      const ordersUnsubscribe = onValue(ordersRef, (snapshot) => {
        const ordersData = snapshot.val();
        const count = ordersData ? Object.keys(ordersData).length : 0;
        setOrdersCount(count);
      });

      // Wishlist count
      const wishlistRef = ref(db, `Watch/customers/${userData.id}/wishlist`);
      const wishlistUnsubscribe = onValue(wishlistRef, (snapshot) => {
        const wishlistData = snapshot.val();
        const count = wishlistData ? Object.keys(wishlistData).length : 0;
        setWishlistCount(count);
      });

      return () => {
        cartUnsubscribe();
        ordersUnsubscribe();
        wishlistUnsubscribe();
      };
    } else {
      const localCart = JSON.parse(localStorage.getItem('cart')) || [];
      setCartCount(localCart.length);

      const localWishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
      setWishlistCount(localWishlist.length);
    }
  }, [userData?.id]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setUserProfileOpen(false);
  };

  const toggleUserProfile = () => {
    setUserProfileOpen(!userProfileOpen);
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    setUserData(null);
    setUserProfileOpen(false);
    setCartCount(0);
    setWishlistCount(0);
    window.location.href = '/';
  };

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Watches', path: '/watches' },
    { name: 'Sunglasses', path: '/sunglasses' },
    { name: 'Clocks', path: '/accessories' },
    { name: 'Collections', path: '/products' },
  ];

  // Responsive styles based on screen size
  const getResponsiveStyles = () => {
    const base = {
      nav: {
        background: 'linear-gradient(135deg, #0f0c29, #302b63, #24243e)',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        padding: screenSize.isMobile ? '0.75rem 1rem' : screenSize.isTablet ? '0.875rem 1.5rem' : '0rem 0rem',
        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.3)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        animation: 'gradientBG 8s ease infinite',
        backgroundSize: '200% 200%'
      },
      container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: screenSize.isMobile ? '100%' : screenSize.isTablet ? '1024px' : '1400px',
        margin: '0 auto',
        width: '100%'
      },
      logo: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'all 0.4s ease'
      },
      logoImg: {
        width: screenSize.isMobile ? '45px' : screenSize.isTablet ? '40px' : '80px',
        height: screenSize.isMobile ? '55px' : screenSize.isTablet ? '40px' : '80px',
        marginRight: screenSize.isMobile ? '0rem' : '0rem',
       
      },
        logoImg1: {
        width: screenSize.isMobile ? '80px' : screenSize.isTablet ? '200px' : '200px',
        height: screenSize.isMobile ? '65px' : screenSize.isTablet ? '70px' : '100px',
        marginRight: screenSize.isMobile ? '0rem' : '0rem',
       
      },
      logoText: {
        fontSize: screenSize.isMobile ? '1.2rem' : screenSize.isTablet ? '1.5rem' : '1.8rem',
        fontWeight: 'bold',
        background: 'linear-gradient(90deg, #ff8a00, #e52e71, #ff8a00)',
        backgroundSize: '200% auto',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        animation: 'gradientText 3s linear infinite',
        textShadow: '0 0 10px rgba(255, 255, 255, 0.2)',
        display: screenSize.isMobile && isMenuOpen ? 'none' : 'block'
      },
      desktopNav: {
        display: screenSize.isDesktop ? 'flex' : 'none',
        gap: '2rem',
        alignItems: 'center'
      },
      tabletNav: {
        display: screenSize.isTablet && !screenSize.isMobile ? 'flex' : 'none',
        gap: '1.5rem',
        alignItems: 'center'
      },
      iconContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: screenSize.isMobile ? '0.75rem' : screenSize.isTablet ? '1rem' : '1.5rem'
      },
      actionIcon: {
        color: 'rgba(255, 255, 255, 0.9)',
        cursor: 'pointer',
        position: 'relative',
        transition: 'all 0.3s ease',
        padding: screenSize.isMobile ? '0.375rem' : '0.5rem',
        borderRadius: '8px',
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(5px)',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
        // animation: 'float 3s ease-in-out infinite',
        flexDirection: 'column',
        width: screenSize.isMobile ? '32px' : '40px',
        height: screenSize.isMobile ? '32px' : '40px',
        justifyContent: 'center',
        alignItems: 'center',
        display: (screenSize.isMobile && isMenuOpen) ? 'none' : 'flex'
      },
      mobileMenuButton: {
        color: 'rgba(255, 255, 255, 0.9)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        padding: '0.5rem',
        borderRadius: '8px',
        display: (screenSize.isMobile || screenSize.isTablet) ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(5px)',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
        animation: 'pulse 2s infinite',
        flexDirection: 'column',
        width: screenSize.isMobile ? '36px' : '40px',
        height: screenSize.isMobile ? '36px' : '40px'
      }
    };
    return base;
  };

  const styles = getResponsiveStyles();

  return (
    <nav style={{
      ...styles.nav,
      background: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
      boxShadow: '0 4px 30px rgba(0, 0, 0, 0.3)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
    }}>
      <div style={{
        ...styles.container,
        position: 'relative',
        overflow: 'visible'
      }}>
        {/* Floating Particles Background */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          zIndex: 0,
          pointerEvents: 'none'
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              position: 'absolute',
              width: `${Math.random() * 6 + 2}px`,
              height: `${Math.random() * 6 + 2}px`,
              background: `rgba(255, ${Math.random() * 55 + 200}, ${Math.random() * 100 + 155}, ${Math.random() * 0.4 + 0.1})`,
              borderRadius: '50%',
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              // animation: `float ${Math.random() * 10 + 10}s linear infinite`,
              animationDelay: `${Math.random() * 5}s`,
              filter: 'blur(1px)'
            }} />
          ))}
        </div>

        {/* Animated Logo */}
        <div
          onClick={() => navigate('/')}
          style={{
            ...styles.logo,
            position: 'relative',
            zIndex: 1,
            
            cursor: 'pointer'
          }}
      
        >
          <img
            src={logo}
            alt="logo"
            style={{
              ...styles.logoImg,
             
            }}
          />
             <img
            src={logo1}
            alt="logo"
            style={{
              ...styles.logoImg1,
            
            }}
          />
        </div>

        {/* Desktop Navigation - Enhanced */}
        <div style={{
          ...styles.desktopNav,
          position: 'relative',
          zIndex: 1,
          gap: '2.5rem'
        }}>
          {navLinks.map((link, index) => (
            <div key={link.name} style={{
              position: 'relative',
              perspective: '1000px'
            }}>
              <a
                href={link.path}
                style={{
                  color: 'rgba(255, 255, 255, 0.9)',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '1.2rem',
                  position: 'relative',
                  padding: '0.75rem 0',
                  transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                  animation: `fadeInUp 0.5s ease-out ${index * 0.1}s both`,
                  display: 'inline-block',
                  transformStyle: 'preserve-3d'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#fff';
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  const highlight = e.currentTarget.querySelector('.nav-highlight');
                  if (highlight) {
                    highlight.style.width = '100%';
                    highlight.style.opacity = '1';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  const highlight = e.currentTarget.querySelector('.nav-highlight');
                  if (highlight) {
                    highlight.style.width = '0%';
                    highlight.style.opacity = '0';
                  }
                }}
              >
                {link.name}
                <span className="nav-highlight" style={{
                  position: 'absolute',
                  bottom: '5px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '0%',
                  height: '4px',
                  background: 'linear-gradient(90deg, #ff8a00, #e52e71)',
                  borderRadius: '4px',
                  transition: 'all 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                  opacity: 0,
                  filter: 'blur(2px)'
                }}></span>
                <span className="nav-underline" style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: '1px',
                  background: 'rgba(255, 255, 255, 0.2)',
                  transformOrigin: 'left center',
                  transform: 'scaleX(0)',
                  transition: 'transform 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
                }}></span>
              </a>
            </div>
          ))}
        </div>

        {/* Action Icons - Enhanced */}
        <div style={{
          ...styles.iconContainer,
          position: 'relative',
          zIndex: 1,
          gap: screenSize.isMobile ? '0.8rem' : '1.2rem'
        }}>
          {/* User Profile */}
          <div
            onClick={toggleUserProfile}
            style={{
              ...styles.actionIcon,
              position: 'relative',
              background: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(5px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
              animationDelay: '0.1s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255, 138, 0, 0.3)';
              e.currentTarget.style.transform = 'translateY(-5px) rotate(5deg)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(255, 138, 0, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.style.transform = 'translateY(0) rotate(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
            }}
          >
            <FiUser style={{
              fontSize: screenSize.isMobile ? '1.1rem' : '1.3rem',
              color: 'rgba(255, 255, 255, 0.9)'
            }} />
            {userData && (
              <span style={{
                position: 'absolute',
                top: '5px',
                right: '5px',
                width: '10px',
                height: '10px',
                background: 'linear-gradient(135deg, #4CAF50, #8BC34A)',
                borderRadius: '50%',
                boxShadow: '0 0 10px rgba(76, 175, 80, 0.8)',
                animation: 'pulse 2s infinite'
              }}></span>
            )}
          </div>

          {/* Orders */}
          <a
            href="/orders"
            style={{
              ...styles.actionIcon,
              position: 'relative',
              background: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(5px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
              animationDelay: '0.2s',
              textDecoration: 'none'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(229, 46, 113, 0.3)';
              e.currentTarget.style.transform = 'translateY(-5px) rotate(-5deg)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(229, 46, 113, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.style.transform = 'translateY(0) rotate(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
            }}
          >
            <FiPackage style={{
              fontSize: screenSize.isMobile ? '1.1rem' : '1.3rem',
              color: 'rgba(255, 255, 255, 0.9)'
            }} />
            {ordersCount > 0 && (
              <span style={{
                position: 'absolute',
                top: '0',
                right: '0',
                background: 'linear-gradient(135deg, #ff8a00, #e52e71)',
                color: 'white',
                borderRadius: '50%',
                width: screenSize.isMobile ? '18px' : '20px',
                height: screenSize.isMobile ? '18px' : '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                fontWeight: 'bold',
                boxShadow: '0 0 15px rgba(229, 46, 113, 0.7)',
                transform: 'translate(30%, -30%)',
                animation: 'pulse 1.5s infinite'
              }}>
                {ordersCount}
              </span>
            )}
          </a>

          {/* Cart */}
          <a
            href="/cart"
            style={{
              ...styles.actionIcon,
              position: 'relative',
              background: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(5px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
              animationDelay: '0.3s',
              textDecoration: 'none'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(100, 255, 218, 0.3)';
              e.currentTarget.style.transform = 'translateY(-5px) rotate(5deg)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(100, 255, 218, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.style.transform = 'translateY(0) rotate(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
            }}
          >
            <FiShoppingBag style={{
              fontSize: screenSize.isMobile ? '1.1rem' : '1.3rem',
              color: 'rgba(255, 255, 255, 0.9)'
            }} />
            {cartCount > 0 && (
              <span style={{
                position: 'absolute',
                top: '0',
                right: '0',
                background: 'linear-gradient(135deg, #00b4db, #0083b0)',
                color: 'white',
                borderRadius: '50%',
                width: screenSize.isMobile ? '18px' : '20px',
                height: screenSize.isMobile ? '18px' : '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                fontWeight: 'bold',
                boxShadow: '0 0 15px rgba(0, 180, 219, 0.7)',
                transform: 'translate(30%, -30%)',
                animation: 'pulse 1.5s infinite'
              }}>
                {cartCount}
              </span>
            )}
          </a>

          {/* Mobile Menu Button - Enhanced */}
          <div
            onClick={toggleMenu}
            style={{
              ...styles.mobileMenuButton,
              background: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(5px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
              e.currentTarget.style.transform = 'scale(1.2) rotate(90deg)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(255, 255, 255, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.style.transform = 'scale(1) rotate(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
            }}
          >
            {isMenuOpen ? (
              <FiX style={{
                fontSize: screenSize.isMobile ? '1.3rem' : '1.5rem',
                color: 'rgba(255, 255, 255, 0.9)'
              }} />
            ) : (
              <FiMenu style={{
                fontSize: screenSize.isMobile ? '1.3rem' : '1.5rem',
                color: 'rgba(255, 255, 255, 0.9)'
              }} />
            )}
          </div>
        </div>

        {/* Mobile/Tablet Menu - Enhanced */}
        {(screenSize.isMobile || screenSize.isTablet) && isMenuOpen && (
          <div style={{
            position: 'fixed',
            top: screenSize.isMobile ? '70px' : '80px',
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(15, 12, 41, 0.98), rgba(48, 43, 99, 0.98))',
            backdropFilter: 'blur(20px)',
            padding: screenSize.isMobile ? '1.5rem' : '2rem',
            boxShadow: '0 20px 50px rgba(0, 0, 0, 0.7)',
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            zIndex: 999,
            display: 'flex',
            flexDirection: 'column',
            gap: screenSize.isMobile ? '1.2rem' : '1.8rem',
            animation: 'slideDown 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
            overflowY: 'auto',
            overflowX: 'hidden'
          }}>
            {/* Floating Circles Decoration */}
            <div style={{
              position: 'absolute',
              top: '-100px',
              right: '-100px',
              width: '300px',
              height: '300px',
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(255,138,0,0.15) 0%, transparent 70%)',
              filter: 'blur(20px)',
              zIndex: -1
            }} />
            <div style={{
              position: 'absolute',
              bottom: '-150px',
              left: '-150px',
              width: '400px',
              height: '400px',
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(229,46,113,0.15) 0%, transparent 70%)',
              filter: 'blur(30px)',
              zIndex: -1
            }} />

            {navLinks.map((link, index) => (
              <a
                key={link.name}
                href={link.path}
                onClick={toggleMenu}
                style={{
                  color: 'rgba(255, 255, 255, 0.9)',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: screenSize.isMobile ? '1.3rem' : '1.5rem',
                  padding: screenSize.isMobile ? '1rem' : '1.2rem 1.5rem',
                  borderRadius: '12px',
                  transition: 'all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                  background: 'rgba(255, 255, 255, 0.05)',
                  animation: `fadeIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) ${index * 0.1}s both`,
                  display: 'flex',
                  alignItems: 'center',
                  backdropFilter: 'blur(5px)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255, 138, 0, 0.2)';
                  e.currentTarget.style.transform = 'translateX(15px) scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(255, 138, 0, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                  e.currentTarget.style.transform = 'translateX(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
                }}
              >
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '1.5rem',
                  width: '40px',
                  height: '40px',
                  background: 'linear-gradient(135deg, #ff8a00, #e52e71)',
                  borderRadius: '50%',
                  boxShadow: '0 0 15px rgba(255, 138, 0, 0.5)',
                  animation: 'pulse 2s infinite alternate'
                }}>
                  <FiChevronRight style={{
                    fontSize: '1.2rem',
                    color: 'white'
                  }} />
                </span>
                {link.name}
              </a>
            ))}

            {/* Mobile-only additional options */}
            {screenSize.isMobile && (
              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '1.5rem',
                marginTop: '1rem',
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '1.2rem'
              }}>
                <a href="/orders" style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: '1.2rem',
                  background: 'rgba(255, 255, 255, 0.05)',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  color: 'rgba(255, 255, 255, 0.9)',
                  transition: 'all 0.4s ease',
                  backdropFilter: 'blur(5px)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(229, 46, 113, 0.2)';
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 10px 25px rgba(229, 46, 113, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <div style={{
                    width: '50px',
                    height: '50px',
                    background: 'linear-gradient(135deg, #ff8a00, #e52e71)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '0.8rem',
                    boxShadow: '0 0 20px rgba(255, 138, 0, 0.5)'
                  }}>
                    <FiPackage style={{ fontSize: '1.5rem', color: 'white' }} />
                  </div>
                  <span style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Orders</span>
                  {ordersCount > 0 && (
                    <span style={{
                      background: 'linear-gradient(135deg, #ff8a00, #e52e71)',
                      color: 'white',
                      borderRadius: '12px',
                      padding: '4px 12px',
                      fontSize: '0.8rem',
                      fontWeight: 'bold',
                      boxShadow: '0 0 10px rgba(255, 138, 0, 0.5)'
                    }}>
                      {ordersCount} items
                    </span>
                  )}
                </a>
                <a href="/cart" style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: '1.2rem',
                  background: 'rgba(255, 255, 255, 0.05)',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  color: 'rgba(255, 255, 255, 0.9)',
                  transition: 'all 0.4s ease',
                  backdropFilter: 'blur(5px)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(100, 255, 218, 0.2)';
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 10px 25px rgba(100, 255, 218, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <div style={{
                    width: '50px',
                    height: '50px',
                    background: 'linear-gradient(135deg, #00b4db, #0083b0)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '0.8rem',
                    boxShadow: '0 0 20px rgba(0, 180, 219, 0.5)'
                  }}>
                    <FiShoppingBag style={{ fontSize: '1.5rem', color: 'white' }} />
                  </div>
                  <span style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Cart</span>
                  {cartCount > 0 && (
                    <span style={{
                      background: 'linear-gradient(135deg, #00b4db, #0083b0)',
                      color: 'white',
                      borderRadius: '12px',
                      padding: '4px 12px',
                      fontSize: '0.8rem',
                      fontWeight: 'bold',
                      boxShadow: '0 0 10px rgba(0, 180, 219, 0.5)'
                    }}>
                      {cartCount} items
                    </span>
                  )}
                </a>
              </div>
            )}
          </div>
        )}

        {/* User Profile Dropdown - Enhanced */}
        {userProfileOpen && (
          <div style={{
            position: 'absolute',
            top: '80px',
            right: screenSize.isMobile ? '1rem' : '2rem',
            background: 'linear-gradient(135deg, rgba(15, 12, 41, 0.98), rgba(48, 43, 99, 0.98))',
            backdropFilter: 'blur(20px)',
            borderRadius: '20px',
            boxShadow: '0 20px 50px rgba(0, 0, 0, 0.6)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            padding: screenSize.isMobile ? '1.5rem' : '2rem',
            width: screenSize.isMobile ? 'calc(100% - 2rem)' : screenSize.isTablet ? '300px' : '350px',
            maxWidth: '90vw',
            zIndex: 1001,
            animation: 'fadeInUp 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
            overflow: 'hidden'
          }}>
            {/* Decorative Elements */}
            <div style={{
              position: 'absolute',
              top: '-100px',
              right: '-100px',
              width: '300px',
              height: '300px',
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(255,138,0,0.15) 0%, transparent 70%)',
              filter: 'blur(20px)',
              zIndex: -1
            }} />
            <div style={{
              position: 'absolute',
              bottom: '-150px',
              left: '-150px',
              width: '400px',
              height: '400px',
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(229,46,113,0.15) 0%, transparent 70%)',
              filter: 'blur(30px)',
              zIndex: -1
            }} />

            {userData ? (
              <div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: screenSize.isMobile ? '1.5rem' : '2rem'
                }}>
                  <div style={{
                    width: screenSize.isMobile ? '60px' : '80px',
                    height: screenSize.isMobile ? '60px' : '80px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #ff8a00, #e52e71)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '1.5rem',
                    fontSize: screenSize.isMobile ? '2rem' : '2.5rem',
                    fontWeight: 'bold',
                    color: 'white',
                    boxShadow: '0 0 30px rgba(255, 138, 0, 0.7)',
                    animation: 'pulse 2s infinite alternate'
                  }}>
                    {userData.username ? userData.username.charAt(0).toUpperCase() : 'U'}
                  </div>
                  <div>
                    <h3 style={{
                      margin: 0,
                      fontSize: screenSize.isMobile ? '1.3rem' : '1.6rem',
                      background: 'linear-gradient(90deg, #ff8a00, #e52e71)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      textShadow: '0 0 15px rgba(255, 138, 0, 0.4)',
                      animation: 'gradientText 5s ease infinite',
                      backgroundSize: '200% auto'
                    }}>
                      {userData.username || 'User'}
                    </h3>
                    <p style={{
                      margin: '0.5rem 0 0',
                      color: 'rgba(255, 255, 255, 0.7)',
                      fontSize: screenSize.isMobile ? '0.9rem' : '1rem',
                      textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)'
                    }}>
                      {userData.email || userData.id}
                    </p>
                  </div>
                </div>

                <button
                  onClick={handleLogout}
                  style={{
                    background: 'linear-gradient(90deg, #ff8a00, #e52e71)',
                    color: 'white',
                    border: 'none',
                    padding: screenSize.isMobile ? '1rem' : '1.2rem',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '1rem',
                    width: '100%',
                    fontWeight: 'bold',
                    fontSize: screenSize.isMobile ? '1rem' : '1.1rem',
                    boxShadow: '0 8px 25px rgba(255, 138, 0, 0.5)',
                    backdropFilter: 'blur(5px)',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 12px 30px rgba(255, 138, 0, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(255, 138, 0, 0.5)';
                  }}
                  onMouseDown={(e) => {
                    e.currentTarget.style.transform = 'translateY(1px)';
                  }}
                  onMouseUp={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                >
                  <FiLogOut style={{ fontSize: '1.3rem' }} />
                  Sign Out
                  <span style={{
                    position: 'absolute',
                    top: '-50%',
                    left: '-50%',
                    width: '200%',
                    height: '200%',
                    background: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 100%)',
                    transform: 'rotate(30deg)',
                    transition: 'all 0.6s ease',
                    opacity: 0
                  }}></span>
                </button>
              </div>
            ) : (
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  width: screenSize.isMobile ? '100px' : '120px',
                  height: screenSize.isMobile ? '100px' : '120px',
                  background: 'linear-gradient(135deg, #ff8a00, #e52e71)',
                  borderRadius: '50%',
                  margin: '0 auto 2rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 0 40px rgba(255, 138, 0, 0.6)',
                  animation: 'pulse 2s infinite alternate'
                }}>
                  <FiUser style={{ fontSize: screenSize.isMobile ? '3rem' : '3.5rem', color: 'white' }} />
                </div>
                <p style={{
                  marginBottom: '2rem',
                  color: 'rgba(255, 255, 255, 0.9)',
                  fontSize: screenSize.isMobile ? '1.1rem' : '1.2rem',
                  lineHeight: '1.6'
                }}>
                  Join our community to unlock amazing features and personalized experiences!
                </p>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1.2rem'
                }}>
                  <a href="/login" style={{
                    background: 'linear-gradient(90deg, #ff8a00, #e52e71)',
                    color: 'white',
                    textDecoration: 'none',
                    padding: screenSize.isMobile ? '1rem' : '1.2rem',
                    borderRadius: '12px',
                    fontWeight: 'bold',
                    transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                    textAlign: 'center',
                    boxShadow: '0 8px 25px rgba(255, 138, 0, 0.5)',
                    fontSize: screenSize.isMobile ? '1rem' : '1.1rem',
                    backdropFilter: 'blur(5px)'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(255, 138, 0, 0.6)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(255, 138, 0, 0.5)';
                    }}
                  >
                    Login
                  </a>
                  <a href="/login" style={{
                    border: '2px solid #ff8a00',
                    color: '#ff8a00',
                    textDecoration: 'none',
                    padding: screenSize.isMobile ? '1rem' : '1.2rem',
                    borderRadius: '12px',
                    fontWeight: 'bold',
                    transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                    textAlign: 'center',
                    background: 'rgba(255, 255, 255, 0.05)',
                    fontSize: screenSize.isMobile ? '1rem' : '1.1rem',
                    backdropFilter: 'blur(5px)'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(255, 138, 0, 0.1)';
                      e.currentTarget.style.transform = 'translateY(-3px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    Register
                  </a>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Animation Keyframes - Enhanced */}
        <style>{`
        @keyframes gradientBG {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        @keyframes gradientText {
          0% { background-position: 0% center; }
          100% { background-position: 200% center; }
        }
        @keyframes pulse {
          0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 138, 0, 0.7); }
          70% { transform: scale(1.05); box-shadow: 0 0 0 15px rgba(255, 138, 0, 0); }
          100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 138, 0, 0); }
        }
        @keyframes float {
          0% { transform: translateY(0px) translateX(0px) rotate(0deg); }
          25% { transform: translateY(-20px) translateX(10px) rotate(5deg); }
          50% { transform: translateY(0px) translateX(-10px) rotate(0deg); }
          75% { transform: translateY(-10px) translateX(0px) rotate(-5deg); }
          100% { transform: translateY(0px) translateX(0px) rotate(0deg); }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes ripple {
          to {
            transform: translate(50%, -50%) rotate(0deg);
            opacity: 1;
          }
          from {
            transform: translate(50%, -50%) rotate(360deg);
            opacity: 0;
          }
        }
        
        /* Enhanced responsive styles */
        @media (max-width: 480px) {
          .nav-container {
            padding: 0.8rem !important;
          }
        }
        
        @media (max-width: 640px) {
          .logo-text {
            font-size: 1.1rem !important;
          }
        }
        
        @media (min-width: 1200px) {
          .nav-container {
            max-width: 1500px !important;
          }
        }
      `}</style>
      </div>
    </nav>
  
  );
};

export default Navbar;
